// RulesPage.jsx
// React equivalent of escape_peace-old/rules1.php — rules screen.
import React from 'react';
import { Link } from 'react-router-dom';
import EscapeHeader from '../../../components/escape-to-inner-peace/layout/EscapeHeader';
import '../../../games/escape-to-inner-peace/styles/theme.css';
import logo from '../../../assets/escape-to-inner-peace/images/logo.png';
import './rules.css';

const RULES = [
  'You are trapped in a room which is a mind palace',
  'Clues will appear as you progress. Navigate through the items in the Room',
  'Think smart. Think fast. Think together',
  'Score maximum in minimum amount of time to be on the leaderboard',
];

function RulesPage() {
  return (
    <div className="escape-rules-page">
      <EscapeHeader backTo="/escape-to-inner-peace/intro" />

      <div className="escape-rules-logo-row">
        <a href="https://extramileplay.com/" aria-label="Visit ExtraMile Play">
          <img src={logo} alt="Escape To Inner Peace" className="escape-rules-logo" />
        </a>
      </div>

      <div className="escape-rules-body">
        <h3 className="escape-rules-title">Rules</h3>

        <ul className="escape-rules-list">
          {RULES.map((rule) => (
            <li key={rule}>{rule}</li>
          ))}
        </ul>

        <div className="escape-rules-action">
          <Link to="/escape-to-inner-peace/game" className="escape-begin-btn">
            Next
          </Link>
        </div>
      </div>
    </div>
  );
}

export default RulesPage;